/**
 * Proposal Schedule — private pilot (Yousef + Behzad only).
 * Keep in sync with src/config/proposalScheduleAccess.js
 *
 * Authority: Yousef's instructions win over Behzad's on discrepancies.
 */
export const YOUSEF_EMAIL = 'yrezaei@laframboise.net';
export const BEHZAD_EMAIL = 'bamiri@laframboise.net';

export const SCHEDULE_COACH_AUTHORITY = [YOUSEF_EMAIL, BEHZAD_EMAIL];

export const PROPOSAL_SCHEDULE_ALLOWED_EMAILS = [...SCHEDULE_COACH_AUTHORITY];

export function isProposalScheduleAllowed(email) {
  const e = String(email || '').trim().toLowerCase();
  return PROPOSAL_SCHEDULE_ALLOWED_EMAILS.includes(e);
}

/** Execution Plan — same private roster (Yousef + Behzad only). */
export const isExecutionPlanAllowed = isProposalScheduleAllowed;

export function isYousefEmail(email) {
  return String(email || '').trim().toLowerCase() === YOUSEF_EMAIL;
}

/** Schedule Analysis — Yousef only. No superadmin bypass. */
export function isScheduleAnalysisAllowed(email) {
  return isYousefEmail(email);
}
